import {
  Grid,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Modal,
  IconButton,
} from "@mui/material";
import { fetchJobsheetView } from "../../../../API Service/apiService";
import { useEffect, useRef, useState } from "react";
import Loader from "../../../../Componants/Loader/Loader";
import { Image } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import CloseIcon from '@mui/icons-material/Close';

// Helper function to format dates
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString; // Return original string if invalid date
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).replace(/ /g, '/');
};

// Helper function to map warranty status to display label
const getWarrantyLabel = (value) => {
  const warrantyMap = {
    'inWarranty': 'In warranty',
    'outOfWarranty': 'Out warranty',
    'voidWarranty': 'Warranty void'
  };
  return warrantyMap[value] || value;
};

// Helper function to map action values to display labels
const getActionLabel = (value) => {
  const actionMap = {
    'repairWithPart': 'Repair with part',
    'replacement': 'Replacement',
    'partPending': 'Part Pending',
    'resolvedWithRemarks': 'Resolved with Remarks'
  };
  return actionMap[value] || value;
};

const JobsheetView = ({ paymentImages = [], images = [], jobID, isPrinting, setJobID }) => {
  // State for form fields
  const [jobData, setJobData] = useState([]);
  
  // State for image modal
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [jobsheetData, setJobsheetData] = useState({
    // Jobsheet Details
    jobsheetNo: "",
    creationDate: "",
    createdBy: "",
    serviceCenter: "",
    jobsheetClosureDate: "",
    jobsheetStatus: "",
    customerRemark: "",
    faultObserverByCustomer: "",

    // Customer Details
    customerName: "",
    mobileNo: "",
    emailId: "",
    address: "",
    alternateNo: "",

    // Product Details
    brand: "",
    category: "",
    subCategory: "",
    model: "",
    serial: "",
    warrantyStatus: "",
    engineerRemark: "",
    dateOfPurchase: "",
    purchaseFrom: "",
    invoiceNo: "",
    invoiceImage: "",
    swapProductSerial: "",
  });
  // State for table data
  const [jobVisitData, setJobVisitData] = useState([
    {
      engineer: "XXXX",
      scheduledDate: "XXXXXXXXX",
      actualVisitDate: "XXXXXXXXX",
      inOutTime: "XXXX",
      engineerRemark: "XXXX",
      customerRemark: "XXXX",
      collectedAmount: "XXXX",
      paymentMode: "XXXX",
      transactionNo: "XXXX",
    },
  ]);

  
const contentRef = useRef();
const reactToPrintFn = useReactToPrint({ contentRef });

  const [partUsedData, setPartUsedData] = useState(jobData?.partDetails || []);

  const [actionLogData, setActionLogData] = useState(jobData.jobHistory || []);
  const [loading, setLoading] = useState(false);

  const getJobsheetViewData = async (jobID) => {
    try {
      setLoading(true);
      const response = await fetchJobsheetView(jobID);
      console.log(response.data.data[0].partDetails);
      if (response.status === 200) {
        // Update all state with response data
        setJobData(response.data.data[0] || []);
        setPartUsedData(response.data.data[0].partDetails || []);
        setActionLogData(response.data.data[0].jobHistory || []);
        setTimeout(() => {
          if(isPrinting){
            reactToPrintFn();
            setTimeout(() => {
             setJobID(null);
            }, 200);
          }
        }, 500);
      }
    } catch (error) {
      console.error("Error fetching jobsheet view:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("job id", jobID);
  useEffect(() => {
    if (jobID) {
    }
    getJobsheetViewData(jobID);
  }, [jobID]);

  // Update jobsheetData when jobData changes
  useEffect(() => {
    if (jobData) {
      setJobsheetData({
        // Jobsheet Details
        jobsheetNo: jobData?.jobNumber || "",
        creationDate: formatDate(jobData?.createdAt) || "",
        createdBy: jobData?.createdBy || "",
        serviceCenter: jobData?.serviceCenterName || "",
        jobsheetClosureDate: formatDate(jobData?.jobClosedDate) || "",
        jobsheetStatus: jobData?.jobStatus || "",
        customerRemark: jobData?.customerRemarks || "",
        faultObserverByCustomer: jobData?.faltObserverByCustomer || "",

        // Customer Details
        customerName: jobData?.customerName || "",
        mobileNo: jobData?.customerMobile || "",
        emailId: jobData?.customerEmail || "",
        address: jobData?.customerAddress || "",
        alternateNo: jobData?.customerAlternateNo || "",

        // Product Details
        brand: jobData?.brandName || "",
        category: jobData?.categoryName || "",
        subCategory: jobData?.subcategoryName || "",
        model: jobData?.modelName || "",
        serial: jobData?.customerProductSerialNumber || "",
        warrantyStatus: jobData?.warrantyStatus || "",
        engineerRemark: jobData?.engineerRemarks || "",
        dateOfPurchase: formatDate(jobData?.dateOfPurchase) || "",
        purchaseFrom: jobData?.purchaseFrom || "",
        invoiceNo: jobData?.invoiceNumber || "",
        invoiceImage: jobData?.invoiceImage || "",
        swapProductSerial: jobData?.swapSerialNumber || "",
      });
    }
  }, [jobData]);

  // Function to handle image click
  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div style={{opacity: isPrinting ? 0 : 1}}>
    <Box ref={contentRef} sx={{ padding: 2, backgroundColor: "#EFF3FE" }}>
      {loading && <Loader  />}
      <Typography variant="h5" align="center" gutterBottom>
        Jobsheet View
      </Typography>
     
      <button onClick={reactToPrintFn}>Print</button>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Jobsheet No"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.jobsheetNo}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Creation Date"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.creationDate}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Created By"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.createdBy}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}></Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Service Center"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.serviceCenter}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Jobsheet Closure Date"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.jobsheetClosureDate}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Jobsheet Status"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.jobsheetStatus}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}></Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Customer Remark"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.customerRemark}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Fault Observed by Customer"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.faultObserverByCustomer}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <p sx={{ fontSize: "900" }}>Customer Details</p>
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            label="Customer Name"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.customerName}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Mobile No"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.mobileNo}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Email Id"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.emailId}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Address"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.address}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Alternate No"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.alternateNo}
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <p sx={{ fontSize: "900" }}>Product Details</p>
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            label="Brand"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.brand}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Category"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.category}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Sub Category"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.subCategory}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Model"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.model}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Serial"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.serial}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Warranty Status"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={getWarrantyLabel(jobsheetData.warrantyStatus)}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}></Grid>
        <Grid item xs={12} sm={4} md={3}></Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Engineer Remark"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.engineerRemark}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Date of Purchase"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.dateOfPurchase}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Purchase from"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.purchaseFrom}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}></Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Invoice No"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.invoiceNo}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Invoice Image"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.invoiceImage}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            label="Swap Product/Serial"
            variant="standard"
            size="small"
            sx={{ width: "10rem" }}
            value={jobsheetData.swapProductSerial}
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>

      <Box mt={4}>
        <Typography
          sx={{
            width: "10rem",
            backgroundColor: "#33499F",
            color: "white",
            borderRadius: "4px 4px 0 0",
          }}
        >
          Job Visit
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#33499F" }}>
              <TableRow>
                <TableCell sx={{ color: "white" }}>Engineer</TableCell>
                <TableCell sx={{ color: "white" }}>
                  Scheduled Date
                </TableCell>
                <TableCell sx={{ color: "white" }}>
                  Scheduled Time
                </TableCell>
                <TableCell sx={{ color: "white" }}>Actual Visit Date</TableCell>
                <TableCell sx={{ color: "white" }}>Actual Visit Time</TableCell>
                <TableCell sx={{ color: "white" }}>Engineer Remark</TableCell>
                <TableCell sx={{ color: "white" }}>faltObserverByCustomer</TableCell>
                <TableCell sx={{ color: "white" }}>Collected Amount</TableCell>
                <TableCell sx={{ color: "white" }}>Payment Mode</TableCell>
                <TableCell sx={{ color: "white" }}>Transaction No</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableCell>{jobData.engineerName}</TableCell>
              <TableCell>{formatDate(jobData.scheduleDate)}</TableCell>
              <TableCell>{jobData.scheduleTime}</TableCell>
              <TableCell>{formatDate(jobData.actualVisitDate)}</TableCell>
              <TableCell>{jobData.actualVisitTime}</TableCell>
              <TableCell>{jobData.engineerRemarks}</TableCell>
              <TableCell>{jobData.faltObserverByCustomer}</TableCell>
              <TableCell>{jobData.collectedAmount}</TableCell>
              <TableCell>{jobData.paymentMode}</TableCell>
              <TableCell>{jobData.TransactionNumber}</TableCell>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box mt={4}>
        <Typography
          sx={{
            width: "10rem",
            backgroundColor: "#33499F",
            color: "white",
            borderRadius: "4px 4px 0 0",
          }}
        >
          PartUsed/Pending
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#33499F" }}>
              <TableRow>
                <TableCell sx={{ color: "white" }}>Repair Action</TableCell>
                <TableCell sx={{ color: "white" }}>Part Name</TableCell>
                <TableCell sx={{ color: "white" }}>Serial</TableCell>
                <TableCell sx={{ color: "white" }}>
                  Swap Product Serial
                </TableCell>
                <TableCell sx={{ color: "white" }}>Quantity</TableCell>
                {/* <TableCell sx={{ color: "white" }}>Used/Pending</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {partUsedData.length > 0 ? (
                partUsedData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{getActionLabel(row.action)}</TableCell>
                    <TableCell>{row.itemName}</TableCell>
                    <TableCell>{row.oldSerialNumber}</TableCell>
                    <TableCell>{row.newSerialNumber || "--"}</TableCell>
                    <TableCell>{row.quantity}</TableCell>
                    {/* <TableCell>{row.usedPending}</TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box mt={4}>
        <Typography
          sx={{
            width: "10rem",
            backgroundColor: "#33499F",
            color: "white",
            borderRadius: "4px 4px 0 0",
          }}
        >
          Jobsheet Action Log
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#33499F" }}>
              <TableRow>
                <TableCell sx={{ color: "white" }}>Action Date</TableCell>
                <TableCell sx={{ color: "white" }}>User</TableCell>
                <TableCell sx={{ color: "white" }}>Action Done</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {actionLogData.length > 0 ? (
                actionLogData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{formatDate(row.actionDate)}</TableCell>
                    <TableCell>{row.actionBy}</TableCell>
                    <TableCell>{getActionLabel(row.action)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          {jobData.repairAction == "replacement" ? (
            <>
            <h3>Old Model Images</h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {jobData.partDetails[0].oldModelImages.length > 0 ? (
              jobData.partDetails[0].oldModelImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  // src={"https://www.sahivalue.com/product-images/PXL_20240217_053801465.jpg/293890000037169035/400x400"}
                  alt={`Repair ${index}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  onClick={() => handleImageClick(image)}
                />
              ))
            ) : (
              <p>No old model images uploaded</p>
            )}
          </div>
          <h3>New Model Images</h3  >
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {jobData.partDetails[0].newModelImages.length > 0 ? (
              jobData.partDetails[0].newModelImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  // src={"https://5.imimg.com/data5/SELLER/Default/2023/6/316193549/NR/NI/AW/53877097/used-oneplus-nord-ce-2-lite-5g-blue-tide-6gb-ram-128gb-storage-500x500.jpg"}
                  alt={`Repair ${index}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  onClick={() => handleImageClick(image)}
                />
              ))
            ) : (
              <p>No new model images uploaded</p>
            )}
          </div>
            </>
          ) : (
            <>
            <h3>Uploaded Repair Images</h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {jobData.partPendingImagePath?.length > 0 ? (
              jobData.partPendingImagePath?.map((image, index) => (
                <img
                  key={index}
                        src={image}
                  // src={"https://www.xparts.in/wp-content/uploads/2022/03/OnePlus-8-Display-With-Touchscreen-1.jpg"}
                  alt={`Repair ${index}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  onClick={() => handleImageClick(image)}
                />
              ))
            ) : (
              <p>No repair images uploaded</p>
            )}
          </div>
          </>

          )}
        
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <h3>Uploaded Payment Images</h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {console.log("jobdata", jobData.paymentImage)}
            {jobData?.paymentImage && jobData.paymentImage.length > 0 ? (
              jobData.paymentImage.map((image, index) => {
                // console.log("image", image),
                return(
                <img
                  key={index}
                  src={image}
                  // src={"https://static.vecteezy.com/system/resources/previews/026/314/639/non_2x/woman-use-smartphone-to-pay-online-purchase-online-shopping-concept-secure-payment-on-internet-payment-success-on-screen-selective-focus-photo.jpg"}
                  alt={`Payment ${index + 1}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleImageClick(image)}
                />)
                }
            )
            ) : (
              <p>No payment images uploaded</p>
            )}
          </div>
        </Grid>
      </Grid>

      {/* Image Modal */}
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="image-modal"
        aria-describedby="image-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 1,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: 'white',
              bgcolor: 'rgba(0, 0, 0, 0.7)',
              '&:hover': {
                bgcolor: 'rgba(0, 0, 0, 0.9)',
              },
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Enlarged view"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                width: 'auto',
                height: 'auto',
              }}
            />
          )}
        </Box>
      </Modal>
    </Box>
    </div>
  );
};

export default JobsheetView;
